import Script from "next/script";

/**
 * @param {string} key
 * @returns {import("react").ReactNode | null}
 */
export const getMatomoScript = (key) => {
  if (!key) {
    return null;
  }

  return (
    <>
      <Script id="matomo-tracking" strategy="afterInteractive">
        {`
          var _paq = window._paq = window._paq || [];
          /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
          _paq.push(['trackPageView']);
          _paq.push(['enableLinkTracking']);
          (function() {
            var u="//matomo.preprod-clevacances.fr/";
            _paq.push(['setTrackerUrl', u+'matomo.php']);
            _paq.push(['setSiteId', '${key}']);
            var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
            g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
          })();
        `}
      </Script>
    </>
  );
};

export const trackMatomoPageView = (url, key) => {
  var _paq = window["_paq"];

  if (!key) {
    console.warn("unable to track, matomo key is missing");
    return;
  }
  if (!_paq) {
    console.warn("unable to track, _paq is not initialized");
    return;
  }

  try {
    _paq.push(["setCustomUrl", url]);
    _paq.push(["setDocumentTitle", document.title]);
    _paq.push(["trackPageView"]);
  } catch (error) {
    console.warn("an error occured while tracking the page with matomo", error);
  }
};
